import { Contact, SupplierOrderDetail } from 'openapi';
import { useEffect } from 'react';
import { UseFormSetValue } from 'react-hook-form';
import type { SaveSemenOrder } from '../index';
import { OptionItemInterface } from 'ui/Inputs/SelectInput';

interface Props {
  setValue: UseFormSetValue<SaveSemenOrder>;
  customerUidFormValue: string | undefined;
  requesterUidFormValue: string | null | undefined;
  existingOrder: SupplierOrderDetail | undefined;
  repeatOrder: SupplierOrderDetail | undefined;
  shippingOptions: OptionItemInterface[];
  contacts: Contact[];
}

/**
 * Small hook to handle/set the shipping product for a contact or requester based on the default shipping product
 */
function useSemenOrderDefaultShipping({
  setValue,
  customerUidFormValue,
  requesterUidFormValue,
  existingOrder,
  repeatOrder,
  contacts,
  shippingOptions,
}: Props): void {
  useEffect(() => {
    if (!existingOrder && !repeatOrder) {
      let contact: Contact | undefined;
      if (requesterUidFormValue) {
        contact = contacts.find(contact => contact.uid === requesterUidFormValue);
      } else if (customerUidFormValue) {
        contact = contacts.find(contact => contact.uid === customerUidFormValue);
      }

      if (contact && contact.default_shipping_product) {
        const shippingProduct = shippingOptions.find(option => option.id === contact.default_shipping_product);
        if (shippingProduct) {
          setValue('shipping_product', String(shippingProduct.id));
        }
      }
    }
  }, [contacts, customerUidFormValue, existingOrder, repeatOrder, requesterUidFormValue, setValue, shippingOptions]);
}

export default useSemenOrderDefaultShipping;
